import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * Store UI global
 *
 * Gère l'état de l'interface utilisateur :
 * - État du drawer (ouvert/fermé)
 *
 * Pour la détection d'appareil, utiliser useDeviceDetection() directement.
 */
export const useUIStore = defineStore('ui', () => {
  // ============================================
  // ÉTAT DU DRAWER
  // ============================================

  const isDrawerOpen = ref(true); // Default to open for desktop

  function openDrawer() {
    isDrawerOpen.value = true;
  }

  function closeDrawer() {
    isDrawerOpen.value = false;
  }

  function toggleDrawer() {
    isDrawerOpen.value = !isDrawerOpen.value;
  }

  return {
    isDrawerOpen,
    openDrawer,
    closeDrawer,
    toggleDrawer,
  };
});
